import FamilyTrackingHero from './components/FamilyTrackingHero';
import Features from '../../components/sharedComponents/Features';
import HowItWorks from "../../components/sharedComponents/HowItWorks";
import WhyDtp from "../../components/sharedComponents/WhyDtp";
import Testimonials from "../../components/sharedComponents/Testimonials";
import { Helmet } from 'react-helmet';
import { bottomFamilyTrackingFeatures } from './data/bottomFamilyTrackingFeatures';
import { familyTrackingTestimonials } from "./data/familyTrackingTestimonials";
import { familyTrackingFeaturesList } from './data/familyTrackingFeaturesList';

const FamilyTracking = () => {
    return (
        <>
            <Helmet>
                <title>Family Location Tracking App for Parents - Device Tracker Plus</title>
                <meta name="description" content="Stay connected with your whole family using live location sharing, geofencing, and speed alerts. The easiest way to track and protect your loved ones." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/familyTracking" />
            </Helmet>
            <FamilyTrackingHero />
            <Features sectionTitle="Essential Features for Families" features={familyTrackingFeaturesList} />
            <HowItWorks stepOne="Sign up online" stepTwo="Register device" stepThree="Start Tracking" />
            <Testimonials testimonials={familyTrackingTestimonials} />
            <WhyDtp reasons={bottomFamilyTrackingFeatures} title="Why Families Trust Device Tracker Plus"/>

        </>
    );
}

export default FamilyTracking;